import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import {
  MALICIOUS_IP_LIST_URL,
  MALICIOUS_IP_LIST,
  MALICIOUS_IP_LIST_RELEASE_URL,
  MALICIOUS_BY_IP_URL,
  MALICIOUS_IP,
  maliciousDataType,
  malicioiusItemPropsType,
  maliciousPropsType,
} from "../constants";
import { useApiRequest } from "../../../system/hooks/useApiRequest";
import { generatePath } from "react-router-dom";
import { getQueryParams } from "../../../system/helpers/urlHelper";
import { useConfig } from "../../../system/hooks/useConfig";
import { isSystemConfig } from "../../../system/api/requestHelper";
import { ErrorType } from "../../../system/types/constants";

export const useMaliciousIpList = (search = "", page = "") => {
  const { apiRequest } = useApiRequest();
  const { config, brandId } = useConfig();
  const params = getQueryParams({ ip: search, page });

  return useQuery({
    queryKey: [MALICIOUS_IP_LIST, config, search, page, brandId],
    queryFn: (): Promise<maliciousDataType> =>
      apiRequest({
        type: "GET_MALICIOUS_IP_LIST",
        request: {
          url:
            generatePath(MALICIOUS_IP_LIST_URL, {
              config,
              brandId,
            }) + `?${params}`,
          method: "GET",
        },
      }),
    enabled: !isSystemConfig(config),
  });
};

export const useMaliciousByIp = (malicious_ip) => {
  const { apiRequest } = useApiRequest();
  const { config, brandId } = useConfig();

  return useQuery({
    queryKey: [MALICIOUS_IP, config, brandId, malicious_ip],
    queryFn: (): Promise<malicioiusItemPropsType> =>
      apiRequest({
        type: "GET_MALICIOUS_IP",
        request: {
          url: generatePath(MALICIOUS_BY_IP_URL, {
            config,
            brandId,
            malicious_ip,
          }),
          method: "GET",
        },
      }),
    enabled: !isSystemConfig(config),
  });
};

export const useReleaseIP = (search, page) => {
  const queryClient = useQueryClient();
  const { apiRequest, apiErrors } = useApiRequest();
  const { config, brandId } = useConfig();

  return useMutation({
    mutationFn: (data: string): Promise<maliciousPropsType> => {
      return apiRequest({
        type: "MALICIOUS_IP_LIST_RELEASE",
        request: {
          url: generatePath(MALICIOUS_IP_LIST_RELEASE_URL, {
            config,
            brandId,
            malicious_ip: data,
          }),
          method: "POST",
        },
      });
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [MALICIOUS_IP_LIST, config, search, page, brandId],
      });
      queryClient.invalidateQueries({
        queryKey: [MALICIOUS_IP, config, brandId, data.id],
      });
      message.success("IP address successfully released!");
    },
    onError: (err: ErrorType) => apiErrors(err),
  });
};
